// extracted by mini-css-extract-plugin
export var $animation_name = "Index-module--$animation_name--6c716";
export var ContentHidden = "Index-module--ContentHidden--2e182";
export var ContentVisible = "Index-module--ContentVisible--97971";
export var ContentWrapper = "Index-module--ContentWrapper--cc18b";
export var ContentWrapper___ageGate = "Index-module--ContentWrapper___ageGate--d0bc5";